export const licenseRenewURL = 'https://www.portainer.io/renew';
